export default __webpack_public_path__ + "static/media/buttonOn.f77c943e.png";